import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState, validateConfiguration } from 'src/api';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { RequestApiError } from 'loopback-react-request';

export interface ValidationDispatcherProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
}

export class ValidationDispatcherComponent extends React.Component<ValidationDispatcherProps, any> {
  componentDidMount() {
    if (this.configuration) {
      this.props.dispatch(validateConfiguration.validate(this.configuration));
    }
  }

  componentDidUpdate(prevProps: ValidationDispatcherProps) {
    const conf = this.configuration;
    const prevConf = prevProps.configuration.result;
    if (
      ((conf && conf.updated_at) !== (prevConf && prevConf.updated_at)) || 
      this.error && !prevProps.configuration.error
    ) {
      if (!conf) {
        return;
      }
      this.props.dispatch(validateConfiguration.validate(conf, this.error));
    }
    if (prevConf && !conf) {
      this.props.dispatch(validateConfiguration.clear());
    }
  }

  public render() {
    return null;
  }

  private get configuration(): ConfigurationModel | undefined {
    return this.props.configuration && this.props.configuration.result;
  }

  private get error(): RequestApiError | undefined {
    return this.props.configuration.error;
  }
}

export const ValidationDispatcher = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(ValidationDispatcherComponent);

export default ValidationDispatcher;
